<app-multimedia-grid-layout [templateColumns]="templateColumns()">
  @for (item of items(); track item.id) {
    <app-multimedia-grid-layout-item>
      <app-multimedia-tile
        mode="select"
        (click)="handleClickEvent(item.id)"
        [isSelected]="isSelected(item.id)"
        [type]="item.type"
        [info]="shouldShowInfo(item)"
        [alt]="item.alt"
        [filename]="item.filename"
        [size]="item.size"
        [previewUrl]="item.thumbnailUrl"
        [extension]="item.extension"
        role="button" />
    </app-multimedia-grid-layout-item>
  }
</app-multimedia-grid-layout>

<div class="flex flex-col items-center gap-3">
  <div>Załadowano {{ count() }} z {{ total() }} elementów multimedialnych</div>

  @if (canLoadMore()) {
    <p-button
      (onClick)="handleLoadMoreClick()"
      appPrimengButton
      label="Załaduj więcej"
      type="button" />
  }
</div>
